<template>
  <Select
    :value="id"
    @on-select="ddddd"
    :clearable="clearable"
    @on-clear="clear"
  >
    <Option v-for="(x, index) in groupTree" :value="x.id" :key="index">{{
      x.name
    }}</Option>
  </Select>
</template>
<script>
export default {
  props: ["id","clearable"],
  data() {
    return {
      groupTree: [],
    };
  },
  methods: {
    ddddd(v) {
      this.$emit("update:id", v.value);
      this.$emit("update:name", v.label);
    },
    clear(v) {
      this.$emit("update:id", "");
      this.$emit("update:name", "");
    },
  },
  mounted() {
    this.utils.getGroupTree().then((data) => {
      this.groupTree = data;
    });
  },
};
</script>




// WEBPACK FOOTER //
// src/components/common/selectItems.vue